import {
    IFormFieldMessage, IFormItemValidationResult, TFormValues,
} from '../../types/redux/forms';
import { IRootState } from '../../types/redux/root';

export const getFormState = (root: IRootState) => root.forms;

export const getFormValues = (layoutId: string) => (root: IRootState): TFormValues => {
    const formState = root.forms[layoutId];
    if (formState && formState.initialValues) {
        return {
            ...formState.initialValues,
            ...formState.editedValues,
        };
    }
    return {};
};

export const getEditedFormValues = (layoutId: string) => (root: IRootState): TFormValues => root.forms[layoutId]?.editedValues || {};

export const getFormFieldValue = (layoutId: string, fieldName: string) => (root: IRootState) => {
    const formState = root.forms[layoutId];
    if (formState && formState.initialValues) {
        const edited = formState.editedValues[fieldName];
        const initial = formState.initialValues[fieldName];
        return typeof edited === 'undefined' ? initial : edited;
    }
    return undefined;
};

export const formModeSelector = (layoutId: string) => (root: IRootState) => root.forms[layoutId]?.mode;

export const formEditedFieldsSelector = (layoutId: string, fields?: string[]) => (root: IRootState): TFormValues => {
    if (Array.isArray(fields)) {
        return fields.reduce((prev, fieldKey) => (typeof root.forms[layoutId]?.editedValues[fieldKey] !== 'undefined' ? {
            ...prev,
            [fieldKey]: root.forms[layoutId]?.editedValues[fieldKey],
        } : prev), {});
    }
    return {};
};

export const formFieldsSelector = (layoutId: string, fields?: string[]) => (root: IRootState): TFormValues => {
    if (Array.isArray(fields)) {
        return fields.reduce((prev, fieldKey) => {
            const formState = root.forms[layoutId];

            if (formState) {
                const { editedValues, initialValues } = formState;

                if (editedValues[fieldKey] || initialValues[fieldKey]) {
                    return {
                        ...prev,
                        [fieldKey]: Object.keys(editedValues).includes(fieldKey) ? editedValues[fieldKey] : initialValues[fieldKey],
                    };
                }
            }

            return prev;
        }, {});
    }
    return {};
};

export const formValidationRulesSelector = (layoutId: string) => (root: IRootState) => root.forms[layoutId]?.validation.rules;

export const formTitlesSelector = (layoutId: string) => (root: IRootState) => root.forms[layoutId]?.titles;

export const formItemValidationResult = (layoutId: string, fieldName: string) => (root: IRootState): IFormItemValidationResult | undefined => root.forms[layoutId]?.validation.result[fieldName];

export const formFieldMessageSelector = (layoutId: string, fieldName: string) => (root: IRootState): IFormFieldMessage | undefined => root.forms[layoutId]?.messages[fieldName];

export const formFieldLayoutsSelector = (layoutId: string) => (root: IRootState) => root.forms[layoutId]?.fieldLayouts;

export const formDataLoadedSelector = (layoutId: string) => (root: IRootState) => !!root.forms[layoutId]?.formDataLoaded;
